// Generated from the approved MagicPath revision 440526908388683776. Do not hand-edit; update the source worktree instead.
import { useState } from 'react';
const observePlate = "/assets/page04-observe.jpg";
const choosePlate = "/assets/page04-choose.jpg";
const directPlate = "/assets/page04-direct.jpg";
const navigation = ['METHOD', 'HOUSE 45', 'INSIGHTS', 'ASSESSMENT'];
const stages = [{
  number: '01',
  name: 'OBSERVE',
  command: 'CATCH THE VOICE.',
  image: observePlate,
  body: 'See it before you move. Name the chase, the escape, and the lie.'
}, {
  number: '02',
  name: 'CHOOSE',
  command: 'HOLD THE LINE.',
  image: choosePlate,
  body: 'Do not negotiate under pressure. Change the environment. Cut access. Execute the rule.'
}, {
  number: '03',
  name: 'DIRECT',
  command: 'PUT THE FORCE TO WORK.',
  image: directPlate,
  body: 'Business. Body. Family. Competition. Creation. Leave an asset behind.'
}];
export const Page04WhatWeActuallyTrain = () => {
  const [activeNav, setActiveNav] = useState('ASSESSMENT');
  const [activeStage, setActiveStage] = useState('OBSERVE');
  return <main className="training2-page">
    <button className="training2-wordmark" type="button" aria-label="IMTHEHOUSE home">IMTHEHOUSE</button>
    <nav className="training2-navigation" aria-label="Primary navigation">
      {navigation.map(item => <button type="button" key={item} className={activeNav === item ? 'active' : ''} onClick={() => setActiveNav(item)} aria-pressed={activeNav === item}>{item}</button>)}
    </nav>
    <header className="training2-header">
      <p>WHAT WE ACTUALLY TRAIN</p>
      <h1>YOUR MIND IS ALLOWED TO DEMAND.<br /><span>IT IS NOT ALLOWED TO DECIDE.</span></h1>
      <div><i aria-hidden="true" /><p>The urge is real. It is not an order. We train the space between what your mind wants and what you do next.</p></div>
    </header>
    <section className="training2-grid" aria-label="Observe, choose, and direct">
      {stages.map(stage => <article key={stage.name} className={activeStage === stage.name ? 'training2-stage active' : 'training2-stage'} onMouseEnter={() => setActiveStage(stage.name)}>
        <button type="button" onClick={() => setActiveStage(stage.name)} onFocus={() => setActiveStage(stage.name)} aria-pressed={activeStage === stage.name}>
          <span className="training2-label"><b>{stage.number}</b><strong>{stage.name}</strong></span>
          <span className="training2-image"><img src={stage.image} alt="" /></span>
          <span className="training2-stage-copy"><strong>{stage.command}</strong><span>{stage.body}</span></span>
        </button>
      </article>)}
    </section>
    <footer className="training2-footer"><span>YOUR MIND SPEAKS.</span><strong>YOU MAKE THE NEXT MOVE.</strong></footer>
  </main>;
};